import { render, staticRenderFns } from "./WorkerWizardReview.vue?vue&type=template&id=efa79390&scoped=true&"
import script from "./WorkerWizardReview.vue?vue&type=script&lang=ts&"
export * from "./WorkerWizardReview.vue?vue&type=script&lang=ts&"
import style0 from "./WorkerWizardReview.vue?vue&type=style&index=0&id=efa79390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa79390",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBadge,VChip,VCol,VContainer,VIcon,VRow})
